import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, of, Subject, Observer } from 'rxjs';

import { LazyService } from 'fui-theme';

import { Lodop, LodopResult, LodopPrintResult } from './interface';
import { AdLodopConfig } from './lodop.config';

// TODO: zone
@Injectable()
export class LodopService implements OnDestroy {
 private _cog: AdLodopConfig;
  private printBuffer: any[] = [];
  private pending = false;
  private _lodop: Lodop = null;
  private _init: Subject<LodopResult> = new Subject<LodopResult>();
  private _events: Subject<LodopPrintResult> = new Subject<LodopPrintResult>();

  constructor(private scriptSrv: LazyService) {
     // this.cog = defCog;
  }

  /**
   * è·åæéæ°è®¾ç½®éç½®
   *
   * **æ³¨ï¼**éæ°è®¾ç½®ä¼åç½®éæ°å è½½èæ¬èµæº
   */
  get cog() {
    return this._cog;
  }
  set cog(value: AdLodopConfig) {
    this._cog = Object.assign(
      {
        url: 'https://localhost:8443/CLodopfuncs.js',
        name: 'CLODOP',
        companyName: '',
        checkMaxCount: 100,
      },
      this._cog,
      value,
    );
  }

  /** äºä»¶åæ´éç¥ */
  get events(): Observable<LodopPrintResult> {
    return this._events.asObservable();
  }

  private check() {
    if (!this._lodop) { throw new Error(`è¯·å¡å¿åè°ç¨ lodop è·åå¯¹è±¡`); }
  }

  private request(): void {
    this.pending = true;

    const url = `${this.cog.url}?name=${this.cog.name}`;
    let checkMaxCount = this.cog.checkMaxCount;
    const onResolve = (status, error?: any) => {
      this._init.next({
        ok: status === 'ok',
        status,
        error,
        lodop: this._lodop,
      });
    };
    const checkStatus = () => {
      --checkMaxCount;
      if (this._lodop.webskt && this._lodop.webskt.readyState === 1) {
        onResolve('ok');
      } else {
        if (checkMaxCount < 0) {
          onResolve('check-limit');
          return;
        }
        setTimeout(() => checkStatus(), 100);
      }
    };

    this.scriptSrv.load(url).then((res: any[]) => {
      if (res.length === 1 && res[0].status !== 'ok') {
        this.pending = false;
        onResolve('script-load-error', res[0]);
        return;
      }
      this._lodop =
        window.hasOwnProperty(this.cog.name) &&
        (window[this.cog.name] as Lodop);
      if (this._lodop === null) {
        onResolve('load-variable-name-error', { name: this.cog.name });
        return;
      }
      this._lodop.SET_LICENSES(
        this.cog.companyName,
        this.cog.license,
        this.cog.licenseA,
        this.cog.licenseB,
      );
      checkStatus();
    });
  }

  /** éç½® lodop å¯¹è±¡ */
  reset() {
    this._lodop = null;
    this.pending = false;
    this.request();
  }

  /** è·å lodop å¯¹è±¡ */
  get lodop(): Observable<LodopResult> {
    if (this._lodop) { return of(<LodopResult>{ ok: true, lodop: this._lodop }); }
    if (this.pending) { return this._init.asObservable(); }

    this.request();

    return this._init.asObservable();
  }

  /** è·åæå°æºåè¡¨ */
  get printer(): string[] {
    this.check();
    const ret: string[] = [];
    const count = this._lodop.GET_PRINTER_COUNT();
    for (let index = 0; index < count; index++) {
      ret.push(this._lodop.GET_PRINTER_NAME(index));
    }
    return ret;
  }

  /**
   * éå ä»£ç è³ `lodop` å¯¹è±¡ä¸ï¼å­ç¬¦ä¸²ç±»æ¯æ `{{key}}` çå¨æåæ°
   *
   * **æ³¨ï¼** ä»£ç æ¯ææå°è®¾è®¡æäº§çå­ç¬¦ä¸²æ°æ®
   *
   * @param code ä»£ç 
   * @param contextObj å¨æåæ°ä¸ä¸æå¯¹è±¡
   * @param parser èªå®ä¹è§£æè¡¨è¾¾å¼ï¼é»è®¤ï¼`/LODOP\.([^(]+)\(([^\n]+)\);/i`
   */
  attachCode(code: string, contextObj?: Object, parser?: RegExp): void {
    this.check();
    if (!parser) { parser = /LODOP\.([^(]+)\(([^\n]+)\);/i; }
    code.split('\n').forEach(line => {
      const res = parser.exec(line.trim());
      if (!res) { return; }
      const fn = this._lodop[res[1]];
      if (fn) {
        let arr: Array<any>;
        try {
          const fakeFn = new Function(`return [${res[2]}]`);
          arr = fakeFn() as any[];
        } catch {}

        if (Array.isArray(arr) && contextObj) {
          for (let i = 0; i < arr.length; i++) {
            if (typeof arr[i] === 'string') {
              arr[i] = arr[i].replace(
                /{{(.*?)}}/g,
                (match, key) => contextObj[key.trim()] || '',
              );
            }
          }
        }
        fn.apply(this._lodop, arr);
      }
    });
  }

  /**
   * æå¼æå°è®¾è®¡å³é­åèªå¨è¿åä»£ç 
   *
   * **æ³¨ï¼** èªå¨çå¬ `On_Return` äºä»¶ï¼è¿è¡åä¼ç§»é¤
   */
  design(): Promise<string> {
    this.check();
    const tid = this._lodop.PRINT_DESIGN();
    return new Promise(resolve => {
      this._lodop.On_Return = (taskID: string, value: boolean | string) => {
        if (tid !== taskID) { return; }
        this._lodop.On_Return = null;
        resolve('' + value);
      };
    });
  }


  private printDo() {
    const data = this.printBuffer.shift();
    if (!data) { return; }
    this.attachCode(data.code, data.item, data.parser);
    const tid = this._lodop.PRINT();
    this._lodop.On_Return = (taskID: string, value: boolean | string) => {
      if (tid !== taskID) { return; }
      this._lodop.On_Return = null;
      this._events.next(
        Object.assign(
          <LodopPrintResult>{
            ok: value === true,
            error: value === true ? null : value,
          },
          data,
        ),
      );
      this.printDo();
    };
  }

  /**
   * ç«å³æå°ï¼ä¸è¬ç¨äºæ¹éå¥æ
   *
   * @param code ä»£ç 
   * @param contextObj å¨æåæ°ä¸ä¸æå¯¹è±¡
   * @param parser èªå®ä¹è§£æè¡¨è¾¾å¼ï¼é»è®¤ï¼`/LODOP\.([^(]+)\(([^\n]+)\);/i`
   */
  print(code: string, contextObj: Object | Object[], parser?: RegExp): void {
    this.check();
    if (contextObj) {
      this.printBuffer.push(
        ...(Array.isArray(contextObj) ? contextObj : [contextObj]).map(item => {
          return { code, parser, item };
        }),
      );
    }
    this.printDo();
  }

  ngOnDestroy(): void {
    this._init.unsubscribe();
    this._events.unsubscribe();
  }
}
